<template lang="pug">
  .panel(:style="computedStyle", :class="{open: open, 'panel-open': open, ['back-color-' + color]: true}")

    .heading.to-click(
      @click="switchOpen"
      tabindex="0"
      @keydown.enter="switchOpen"
      :class="{'closer-button': closerButton}"
    )
      .heading-main.noselect
        slot(name="heading")

      .heading-button
        .icon.icone-linha-seta-baixo.fw-bold(:class="{open: open}")

    transition(name="pop")
      .panel-collapse(v-show="open")
        slot

</template>

<script>
export default {
  name: 'vue-accordion',
  emits: ['open'],
  props: {
    marginBottom: {default: 0},
    overflow: {type: String, default: 'visible'},
    maxHeight: {type: String, default: 'none'},
    noPanel: {default: null},
    startOpen: {default: false},
    color: {type: String, default: 'primary'},
    closerButton: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false}
  },
  data () {
    return {
      open: this.startOpen
    }
  },
  computed: {
    computedStyle () {
      return {
        overflow: this.overflow,
        marginBottom: this.marginBottom,
        maxHeight: this.maxHeight
      }
    }
  },
  methods: {
    switchOpen () {
      if (this.disabled) return
      this.open = !this.open
      this.$emit('open', this.open)
      return false
    },
    close () {
      this.open = false
    }
  }
}
</script>

<style scoped lang="scss">
$colors: success, danger, info, warning, danger, default, primary;
@each $color in $colors {
  .back-color-#{$color} {
    --accordion-cor: var(--color-#{$color});
    --accordion-contraste: var(--texto-forte);
    border: 1px solid var(--borda);
    .heading {
      border-top: 3px solid var(--accordion-cor);
      border-bottom: 1px solid var(--borda);

      .heading-main, .heading-button {
        background-color: var(--superficie-sutil);
        color: var(--accordion-contraste);
      }

      .heading-button .icon {
        color: var(--accordion-cor);
      }
    }
  }
}
.panel {
  height: fit-content;
  background-color: var(--superficie-cartao);
  color: var(--texto-forte);
  font-family: var(--texto-tipografia, var(--front-font));
  border-radius: 12px;

  &.open {
    .icon.open {
      transform: rotate(180deg);
    }
  }
  .heading {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 40px;
    grid-template-rows: auto;
    align-items: center;
    min-height: 40px;
    outline: none;
    grid-template-areas:
      "main button";
    border: none;
    background: none;

    .heading-main {
      display: grid;
      align-items: center;
      grid-area: main;
      min-height: 40px;
      padding: 8px 12px;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      border-top-left-radius: 12px;
      border-bottom-left-radius: 12px;
    }
    .heading-button {
      display: grid;
      width: 100%;
      height: 100%;
      grid-area: button;
      align-items: center;
      justify-items: center;
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
      .icon {
        transition: all .3s ease;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 20px;
        width: 20px;
      }
    }
  }

  .closer-button{
    grid-template-columns: max-content min-content;
  }

  .panel-collapse:not(:empty) {
    padding: 16px;
  }

  .panel-open > .icon{
    transform: rotate(180deg);
    color: var(--color-primary);
  }
}

.pop-enter-active,
.pop-leave-active {
  transition: max-height 0.4s, opacity 0.35s;
}
.pop-enter-from {
  opacity: 0;
  max-height: 0;
}
.pop-enter-to {
  opacity: 1;
  max-height: 500px;
}
.pop-leave-from {
  opacity: 1;
  max-height: 500px;
}
.pop-leave-to {
  opacity: 0;
  max-height: 0;
}
</style>
